// components/BookingDetails/NotesSection.jsx
import React from "react";
import { Typography, TextField } from "@mui/material";
import NotesIcon from "@mui/icons-material/Notes";

const NotesSection = ({ 
  notes, 
  setNotes, 
  placeholder = "Describe concerns, or reason for the visit...",
  disabled = false
}) => {
  return (
    <div>
      <Typography
        variant="subtitle2"
        fontWeight="bold"
        mb={0.5}
        className="flex items-center gap-2"
      >
        <NotesIcon sx={{ fontSize: 16, color: "#6b7280" }} />
        Notes
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        size="small"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        sx={{
          mb: 1,
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "white",
            border: "1px solid #e5e7eb",
            "&:hover": {
              borderColor: disabled ? "#e5e7eb" : "#6b7280",
              boxShadow: disabled ? "none" : "0 4px 12px rgba(107, 114, 128, 0.15)",
            },
            "&.Mui-focused": {
              borderColor: disabled ? "#e5e7eb" : "#6b7280",
              boxShadow: disabled ? "none" : "0 0 0 3px rgba(107, 114, 128, 0.1)",
            },
            "&.Mui-disabled": {
              backgroundColor: "#f9fafb",
              color: "#9ca3af",
            },
          },
        }}
      />
    </div>
  );
};

export default NotesSection;